import React, { useContext, useEffect, useState } from 'react'
import { Outlet, useLoaderData, useLocation, useMatches, useNavigate, useOutletContext } from 'react-router-dom';
import { Breadcrumb, message, Spin, Flex } from 'antd';
import PosSessionHeader from './components/PosSessionHeader';
import PosSessionContext from './utils/PosSessionContext';
import usePosSessionReducer from './utils/usePosSessionReducer';
import { isSessionClosed } from './apis/sessionAPI';
import EventEmitter from '../utils/eventEmitter';
import AuthContext from '../utils/AuthContext';
import useCalculator from './utils/useCalculator';
// import reducer, { initialState } from './utils/usePosSessionReducer';
// import { StateProvider } from './utils/StateProvider';



const PosLayout = () => {
  const session = useLoaderData();
  const { user } = useContext(AuthContext);
  const [messageApi, contextHolder] = message.useMessage();
  const { state, dispatch, getOrder, createNewOrder, removeOrder } = usePosSessionReducer(user);
  const location = useLocation();
  const pathName = location.pathname.replaceAll('-', ' ');
  const matches = useMatches();
  const [toggleHeader, setToggleHeader] = useState(false);
  const [cashier, setCashier] = useState({});
  const navigate = useNavigate();
  const [tax, setTax] = useState({});

  let crumbs = matches 
    // first get rid of any matches that don't have handle and crumb
    .filter((match) => Boolean(match.handle?.crumb))
    // now map them into an array of elements, passing the loader
    // data to each one 
    .map((match) => match.handle.crumb(match.data));


  const success = (message) => {
    messageApi.open({
      type: 'success',
      content: message,
    });
  };

  const error = (message) => {
    messageApi.open({
      type: 'error',
      content: message,
    });
  }; 


  useEffect(() => {
    dispatch({event: 'LOAD_SESSION_ORDERS'});
    const cashier_ = localStorage.getItem('caspian_pos_cashier');
    const mySession = localStorage.getItem('caspian_pos_session');
    
    let user_ = JSON.parse(cashier_);

    if (user_.pin === '' || user_.pin === undefined || user_.pin === null) {
      if (!(location.pathname === '/pos/session' || location.pathname == '/pos/session/')) {
        navigate('/pos/session');
      }
    }else {
      setCashier(user_);
    };
    const mySession_ = JSON.parse(mySession);
    isSessionClosed(error, mySession_.session_id) 
    .catch(err => console.log(err));
    
    const tax_ = localStorage.getItem('caspian_pos_tax');
    setTax(JSON.parse(tax_));
    EventEmitter.subscribe('cashier_choosen', data => setCashier(data));

    return () => EventEmitter.unsubscribe('cashier_choosen');
  },[])

  useEffect(() => {
    if (location.pathname === '/pos/session' || location.pathname === '/pos/session/') {
      setToggleHeader(true);
    }else {
      setToggleHeader(false);
    }
  },[location.pathname])

  // console.log(state)

  // if (location.pathname === '/pos' || location.pathname === '/pos/') window.location.href = '/pos/sells'

  return (
    <div className='bg-slate-100'>
      
      {!toggleHeader && <PosSessionHeader error={error} success={success} state={state} dispatch={dispatch} createNewOrder={createNewOrder} cashier={cashier} user={user} />}
      {contextHolder}
      <PosSessionContext.Provider value={{state, dispatch, order: getOrder(state.orders), createNewOrder, removeOrder, cashier, user, tax, getOrder}} >
        {/* <Breadcrumb>
          {crumbs.map((crumb, idx) => 
            <Breadcrumb.Item key={idx}>{crumb}</Breadcrumb.Item>
          )}
        </Breadcrumb> */}
        {/* <SellPage Outlet={Outlet}/> */}
        {state.session_id ? 
          <Outlet context={{success, error, sessionOrders: session, }}/>:
          <Flex gap={'middle'} justify='center' align='center' className='w-full' style={{minHeight: '90vh'}}>
            <Spin tip='Loading' size='large'>
              <div style={{
                    padding: 50,
                    background: 'rgba(0, 0, 0, 0.05)',
                    borderRadius: 4,
                  }}>
              </div>
            </Spin>
          </Flex>
        }
      </PosSessionContext.Provider>
    </div>
  )
}

export default PosLayout;